import { gql } from "graphql-tag";

export const GET_APPOINTMENTS = gql`
  query GetAppointments(
    $skip: Int
    $take: Int
    $filters: AppointmentFilterInput
    $sortField: String
    $sortDirection: SortDirection
  ) {
    appointments(
      skip: $skip
      take: $take
      filters: $filters
      sortField: $sortField
      sortDirection: $sortDirection
    ) {
      data {
        id
        source
        kind
        startDate
        durationDisplay
        typeLabel
        title
        description
        contactDisplay
        linkPath
        isAllDay
        done
        eventTypeColor
      }
      total
      page
      limit
    }
  }
`;
